import { render, staticRenderFns } from "./AddOrEditHubForm.vue?vue&type=template&id=2a102be8"
import script from "./AddOrEditHubForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditHubForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports